import { CandidateBatchStatus } from 'generated-graphql/types';

export const STATUS_FILTER_ID = 'status' as const;

export const statusFilterOptions = [
  CandidateBatchStatus.Draft,
  CandidateBatchStatus.Live,
  CandidateBatchStatus.Archived,
  CandidateBatchStatus.RankingCandidates
];

/**
 * Represents a status filter applied to the analyses table.
 * Analyses table only supports filtering by status.
 */
export type AnalysisFilter = {
  filterId: typeof STATUS_FILTER_ID;
  value: CandidateBatchStatus;
  label: string;
};
